import { Component, OnInit, ElementRef, AfterViewChecked } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { TextBoxViewModel, ValueControlViewModel } from '../../types/control.types';
import { ControlTypeName } from '../../types/control-type-name';

@Component({
  selector: 'df-multi-line-text-box',
  templateUrl: './multi-line-text-box.component.html',
  styleUrls: ['./multi-line-text-box.component.css']
})
export class MultiLineTextBoxComponent extends AbstractValueControlBase<TextBoxViewModel>
  implements OnInit, AfterViewChecked {
  type: string = ControlTypeName.multiTextBox;

  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewChecked(): void {
    this.handleValueChangeNotByAngularWay();
  }

  valueChange(event: Event) {
    this.validate();
    super.valueChange(event);
  }
}
